import React, {useState} from 'react';
import { SafeAreaView } from 'react-native-safe-area-context';
import { Button, Divider, Layout, Text, Icon, Select, SelectItem, IndexPath, CheckBox, Input, Modal, Card } from '@ui-kitten/components';
import { StyleSheet, ScrollView, Image, Dimensions, View, TouchableOpacity } from 'react-native';
import {AutocompleteSimpleUsageShowcase} from './autocomplete.js'
import trackerApi from '../../api/tracker';
import { showMessage, hideMessage } from "react-native-flash-message";

import {useSelector, useDispatch} from 'react-redux';

const PlusIcon = (props) => (
  <Icon {...props}  name='plus-square-outline'/>
);
const TrashIcon = (props) => (
  <Icon {...props}  name='trash' />
);

  const AlertIcon = (props) => (
    <Icon {...props} name='alert-triangle' style={{width:16, height:16, marginHorizontal: 10}} fill='#ffffff'/>
  );
const  width= Dimensions.get('window').width-40
export const Done = ({ navigation, model, setActions, actions }) => {
  // const [eqdamat, setActions] = useState([]);
  const [visible, setVisible] = React.useState(false);
  const [serviceSelectedIndex, setServiceSelectedIndex] = useState(new IndexPath(0));
  const [services, setServices] = useState([])
  const [selectedTariff, setSelectedTariff] = useState()
  const [qty, setQty] = useState(1)

  const getTariffs = async() =>{
    const response = await trackerApi.post('/clsient/tariff', {model});
    if(response.data.status){
      setServices(response.data.allData)
    }
    else {
      showMessage({
        message: `خطای دیتابیس`,
        type: "danger",
        icon: AlertIcon
      });
    }
  }
  React.useEffect(()=>{
    getTariffs()
  },[model])

  const clickAdd = ()=>{
    const mw = actions;
    mw.push({title:selectedTariff.service_name, price:selectedTariff.service_cost, tariff_id:selectedTariff.id, qty})
    setActions(mw)
    setVisible(false);

  }

  const deleteItem = (title) =>{
    console.log(title);
    const test = []
    for (let i = 0; i < actions.length; i++) {
        if (actions[i].title !== title) {
            test.push(actions[i]);
        }
    }
    setActions(test)
    console.log(test);
  }
  return (
    <>
        <Text category='c1' appearance='hint' style={{marginTop:15,textAlign:'center'}}>اقدامات</Text>

        <Layout style={{borderRadius:15 , width, marginBottom:10, padding:15, alignItems:'center'}}>
        {actions.length > 0 &&
        <View>
        <Text category='c1' status='danger' style={{marginBottom:10}}>جهت حذف هر آیتم در لیست اقدامات چند ثانیه آن را نگه دارید.</Text>

          <View style={{flexDirection:'row', justifyContent: 'space-between',  width: width-20, marginBottom:5}}>
            <View style={{width: width*0.65}}>
              <Text category='c1' status='primary'>شرح</Text>
            </View>
            <View style={{width: width*0.1}}>
              <Text category='c1' status='primary'>تعداد</Text>
            </View>
            <View style={{width: width*0.25}}>
              <Text category='c1' status='primary'>مبلغ</Text>
            </View>
          </View>
        </View>
}
        { !actions.length > 0 ?
          <Text category='c1' appearance='hint' style={{marginBottom:10,width:width*0.7, textAlign:'center'}}>موردی برای نمایش وجود ندارد. با استفاده از قسمت افزودن لیست اقدامات انجام گرفته را تکمیل نمایید.</Text>
          : actions.map((data, index) => {
            return(
              <TouchableOpacity
                onLongPress={()=>{deleteItem(data.title)}}
                style={{flexDirection:'row', justifyContent: 'space-between',  width: width-20, marginBottom:5}}>
              <View style={{width: width*0.6}}>
                <Text category='c1'>{index+1}_ {data.title}</Text>
              </View>
              <View style={{width: width*0.1 , marginHorizontal:5}}>
                <Text category='c1'> x {data.qty}</Text>
              </View>
              <View style={{width: width*0.25}}>
                <Text category='c1'>{Number(data.price) * Number(data.qty)} ریال</Text>
              </View>
              </TouchableOpacity>
            )
          }) }
          <View style={{flexDirection:'row', justifyContent:'space-between'}}>
            <Button  onPress={() => setActions([])} appearance='ghost' style={{marginTop:10, borderRadius:50, flex:1, marginHorizontal:5}} accessoryLeft={TrashIcon}></Button>
            <Button  onPress={() => setVisible(true)} appearance='outline' style={{marginTop:10, borderRadius:50, flex:2, marginHorizontal:5}} accessoryLeft={PlusIcon}>افزودن</Button>
          </View>
        </Layout>
        <Modal
        visible={visible}
        backdropStyle={styles.backdrop}
        onBackdropPress={() => setVisible(false)}>
        <Card disabled={false} style={{ maxWidth: width*0.95}}>
          <Text>موارد انجام شده را از لیست انتخاب نمایید</Text>
          <AutocompleteSimpleUsageShowcase model={model} setSelect={setSelectedTariff}/>
          {/*<Select
            style={{flex:1, margin:10}}
            label={evaProps => <Text {...evaProps}>قطعه یا سرویس</Text>}
            selectedIndex={serviceSelectedIndex}
            value = {services[serviceSelectedIndex.row]?services[serviceSelectedIndex.row]['service_name'] : null}
            onSelect={index => setServiceSelectedIndex(index)}>
            {
              services.map((data)=>{
                  return <SelectItem title={data.service_name}/>
              })
            }
          </Select>*/}
          <Input keyboardType='numeric' style={{flex:1, margin:10}} value={qty} label='تعداد' onChangeText = {newValue =>{ setQty(newValue)}}/>
          <View style={{alignItems:'center', flexDirection:'row', justifyContent:'flex-end', marginBottom:15}}>
            <Text category='c1'>قیمت واحد: </Text>
          {/*  <Text category='h6' status='primary'>{services[serviceSelectedIndex.row]?services[serviceSelectedIndex.row]['service_cost'] : 0}</Text>
            */}
            <Text category='h6' status='primary'>{selectedTariff ? selectedTariff.service_cost : 0}</Text>
            <Text category='c1'> ریال</Text>
          </View>
          <View style={{flexDirection:'row' , justifyContent:'space-between'}}>
          <Button size='small' appearance='ghost' onPress={() => setVisible(false)}>
            بازگشت
          </Button>
          <Button size='small' onPress={() => clickAdd()}>
            افزودن
          </Button>
          </View>
        </Card>
      </Modal>
    </>
  );
};

const styles = StyleSheet.create({
  container:{
    flex:1,
    justifyContent:'space-around',
    alignItems:'center'
  },
  backdrop: {
    backgroundColor: 'rgba(0, 0, 0, 0.5)',
  },
});
